<template>
<div>
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
		<div class="screen-box">
			<div class="screen-label">快手id</div>
			<a-input v-model="r_user_id" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
		<div  v-for="(item,index) in rableTitle" :key="index" >
			<div class="table-th-cell" 
			:style="{'width':item.width + 'px',}">
				{{item.title}}
			</div>
		</div>
	</div>
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		
		<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex <= sticky_index" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
			</template>
		</div>
		
		<template v-for="(z_tem,z_ndex) in rableTitle">
			<div v-if="z_ndex > sticky_index && z_tem.type != 'cz'" class="table-td-cell"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}}
			</div>
			<div v-else-if="z_ndex > sticky_index &&z_tem.type == 'cz'" class="table-td-cell"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				<div @click="tdHandle(1,item)" style="color: #62a8ea;cursor: pointer;">同步快手id下广告主信息</div>
			</div>
		</template>
		
	</div>
	
	<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { accountKSAuth, accountKSAuthSync } from '@/request/api'
export default {
	name: 'ksIDTable',
	props: [],
	data(){
		return {
			rableTitle: [
				{title:"快手id", width:180, type:"user_id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"开发者应用名称", width:180, type:"account_name", },
				{title:"开发者应用appid", width:180, type:"appid", },
				
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			sticky_index: 1,
			search_button_loading: false,
			
			r_page: 1,
			r_limit: 100,
			table_total: 0,
			r_user_id: null,
		}
	},
	mounted(){
		let that = this
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, 60)
		that.table_scroll_width = table_info.table_width - 60 // 上一级的一个大盒子有一个左右的内边距，-60就是为了消除这个边距（并不是最外面盒子的边距）
		
		that.searchButton()
	},
	methods: {
		// 搜索
		searchButton(type){
			let that = this
			
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				page: that.r_page,
				limit: that.r_limit,
				user_id: that.r_user_id,
			}
			accountKSAuth(r_data).then(res=>{
				console.log("搜索快手ID",res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					let data = res.data.data.data
					
					if(type == 'button'){
						that.$message.success('搜索成功');
					}
					
					that.table_total = res.data.data.total
					that.tableShowData = data
				}
				else {
					
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			
			
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		tdHandle(e,item){
			console.log("item",item);
			let that = this
			if(e == 1){ // 同步快手id下广告主信息
				that.search_button_loading = true
				accountKSAuthSync({
					user_id: item.user_id
				}).then(res=>{
					that.search_button_loading = false
					console.log("同步快手id下广告主信息",res);
					that.$message.success(res.data.msg || "操作成功")
				})
			}
		},
	},
}
</script>

<style>
</style>